// extracted by mini-css-extract-plugin
module.exports = {"li":"NavItem_li__pIGWx","hovered":"NavItem_hovered__SWKb4","link":"NavItem_link__hpp83","whited":"NavItem_whited__gZjuI","item":"NavItem_item__Yc_wR"};